import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';

import Typography from '@material-ui/core/Typography';
import PreviousIcon from '@material-ui/icons/ArrowBack';
import NextIcon from '@material-ui/icons/ArrowForward';

export default function PageNav(props) {
  return (
    <Div>
      {props.prevPage && (
        <StyledLink to={props.prevPage.path} align="left">
          <PreviousIcon />
          <LinkText>
            <Typography component="div" className="link-title">
              {props.prevPage.title}
            </Typography>
          </LinkText>
        </StyledLink>
      )}
      {props.nextPage && (
        <StyledLink to={props.nextPage.path} style={{ marginLeft: 'auto' }}>
          <LinkText align="right">
            <Typography component="div" className="link-title">
              {props.nextPage.title}
            </Typography>
          </LinkText>
          <NextIcon />
        </StyledLink>
      )}
    </Div>
  );
}

PageNav.propTypes = {
  prevPage: PropTypes.object,
  nextPage: PropTypes.object,
};

PageNav.defaultProps = {
  prevPage: null,
  nextPage: null,
};

const Div = styled.nav`
  display: flex;
  padding: 64px 0;
  @media screen and (max-width: ${props => props.theme.breakpoints.values.md}px) {
    padding: 32px 0;
  }
`;

const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
  color: inherit;
  text-decoration: none;
  &:hover {
    opacity: 0.8;
  }

  .link-heading {
    color: ${props => props.theme.colors.minor};
  }
`;

const getLinkStyle = ({ align = 'left', theme }) => {
  const marginProperty = `margin-${align}`;
  return `
    ${marginProperty}: 24px;
    text-align: ${align};
    @media screen and (max-width: ${theme.breakpoints.values.md}px) {
      ${marginProperty}: 16px;
    }
  }`;
};

const LinkText = styled.div`
  ${props => getLinkStyle(props)}
`;
